import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Spoluprace from './components/Collaboration';
import References from './components/References';
import Contact from './components/Contact';
import Footer from './components/Footer';


function App() {
  return (
    <div>
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Spoluprace />
        <References />
        <Contact />
        <Footer />
      </main>
    </div>
  );
}

export default App;

